import React, { memo } from 'react'
import { Text } from 'common-components'
import { THUNDER_ICON } from 'consts/mediaUrls'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { ICreditInfo } from '../creditUtils'
import * as Styled from './styled'

interface ICreditChipProps {
  info: ICreditInfo
}

const CreditChip: React.FC<ICreditChipProps> = ({ info }) => (
  <Styled.Chip>
    {info.isFree ? (
      <>
        <Styled.ThunderImage src={THUNDER_ICON} alt="" />
        <Text type="p" color="secondarySemiDark" lineHeight="1">
          {translate(T.CREDIT_FREE_LABEL)}
        </Text>
      </>
    ) : (
      <>
        <Text type="p" color="secondarySemiDark" lineHeight="1">
          {translate(T.CREDIT_FROM_LABEL)}
        </Text>
        <Styled.Wrapper>
          <Styled.ThunderImage src={THUNDER_ICON} alt="" />
          <Text type="p" color="secondarySemiDark" lineHeight="1">
            {info.minCredits}
          </Text>
        </Styled.Wrapper>
      </>
    )}
  </Styled.Chip>
)

export default memo(CreditChip)
